import { PPTEditorStateEnumType, PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IReactionDisposer } from 'mobx';

export type IEditorStateCallback = (state: PPTEditorStateEnumType) => boolean;

export interface IStateOptions {
    state: PPTEditorStateEnumType;
    scope?: Scope; // 默认值是Scope.ALL
}

export enum Scope {
    // 默认值，修改service和所有slide上的pptEditorState
    ALL = 'serviceAndAllSlides',
    // 只修改当前页的状态
    CURRENT = 'serviceAndCurrentSlide',
    // 只修改Service上的pptEditorstate，不修改SlideModel的state
    SERVICE = 'service',
}

export interface IUserPriviledgeService {
    // 是否锁住编辑器状态， true：不允许再修改编辑器状态， false：允许修改
    isLockEditorState: boolean;

    // 文档权限（文档自身的真实权限）
    fileAuth: PPTEditorStateEnumType;

    // 取消订阅
    disposeReaction: IReactionDisposer;

    /**
     * 当前用户是否超过了最高协作数量，如果超过，则锁定只读
     */
    isOverCoorperateNum: boolean;
    /**
     * ppt 编辑器状态
     */
    pptEditorState: typeof PPTEditorStateType[keyof typeof PPTEditorStateType];
    /**
     * 判断是否可编辑
     * @returns 是否可编辑
     */
    isEditable: () => boolean;

    /**
     * 更新历史版本状态
     * @param isHistory { boolean }
     * @param canUpdateEditorState 是否允许修改编辑器状态
     */
    updateHistoricalVersionStatus: (isHistory: boolean, canUpdateEditorState: boolean) => void;

    /**
     * 获取历史版本状态
     * @returns
     */
    getHistoricalVersionStatus: () => boolean;

    // 设置编辑器状态
    setPPTEditorState(stateOptions: IStateOptions): void;

    /**
     * 监听PPTEditorStateChange
     * @param callback 回调
     * @returns 返回一个函数，调用该函数可以取消监听
     */
    onPPTEditorStateChange(callback: (state: PPTEditorStateEnumType) => void): Function;

    addStateWillChangeCallbacks(callback: IEditorStateCallback): Function;
}
